<template>
    <el-dialog :visible="visible" width="550px" class="small-edit-dialog" :close-on-click-modal="false" @close="handleClose" @open="onOpen">
        <div class="title">{{ getTitle }}</div>
        <el-form :rules="rules" ref="form" label-width="120px" :model="form" label-position="right">
            <el-form-item label="來源">
                <el-radio-group v-model="form.src" :disabled="form.sno != null" @change="handleTypeChange">
                    <el-radio-button :label="1">銀行帳戶</el-radio-button>
                    <el-radio-button :label="2">非銀行帳戶</el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item prop="nam" label="摘要">
                <el-input v-model="form.nam" placeholder="請輸入摘要" :maxlength="100" :show-word-limit="true" />
            </el-form-item>
            <el-form-item prop="bnK_SNO" v-if="isShowBankSelect" label="轉出帳戶">
                <ah-el-select-bank-account v-model="form.bnK_SNO" document-type="petty-cash" cny="TWD" hide-borrower></ah-el-select-bank-account>
            </el-form-item>
            <el-form-item prop="dat" label="日期">
                <el-date-picker v-model="form.dat" type="date" value-format="timestamp" placeholder="選擇日期"> </el-date-picker>
            </el-form-item>
            <el-form-item prop="amt">
                <template v-slot:label>
                    金額
                    <ahTip>
                        如有產生手續費，請至「財務 / 財務收支管理」-「新增一筆財務支出」登載
                    </ahTip>
                </template>
                <money-input v-model="form.amt" @change="onAmtChange" />
            </el-form-item>
            <el-form-item prop="mem" label="備註">
                <el-input
                    ref="mem"
                    type="textarea"
                    v-model="form.mem"
                    :placeholder="`請輸入${form.sno ? '編輯原因或其他' : ''}備註`"
                    :autosize="{ minRows: 4 }"
                    :maxlength="200"
                    :show-word-limit="true"
                />

                <el-input v-if="isAmtChange" type="textarea" :value="autoMem" :rows="3" disabled resize="none" :maxlength="200" :show-word-limit="true" />
            </el-form-item>
        </el-form>
        <div class="main-action" style="text-align: right">
            <el-button v-if="form.sno && !isQR()" type="danger" @click="onDelete">刪除</el-button>
            <el-button v-if="!isQR()" type="primary" class="primary-action" :loading="isLoading" @click="handleSubmit">
                <span v-if="isInitial || inputData">儲存變更</span>
                <span v-else>轉入</span>
            </el-button>
            <el-button :loading="isLoading" @click="handleClose">取消</el-button>
        </div>
        <el-alert v-if="inputData && inputData.upD_USR" :closable="false" style="line-height: 100%; margin-top: 15px"
            >最後編輯：{{ inputData.upD_USR }} {{ inputData.upD_DAT | dateFormater("YYYY-MM-dd") }}</el-alert
        >
    </el-dialog>
</template>
<script>
import moment from 'moment';
import ahElSelectBankAccount from '@/components/ui/ahElSelectBankAccount.vue';

export default {
    components: { ahElSelectBankAccount },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        inputData: {
            type: Object,
            default: null,
        },
        isInitial: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isAmtChange: false,
            isLoading: false,
            form: {
                sno: null,
                nam: null,
                bnK_SNO: null,
                dat: Number(
                    moment()
                        .startOf('day')
                        .format('x'),
                ),
                amt: null,
                mem: '',
                src: 1,
            },
            rules: {
                nam: [{ required: true, message: '請輸入摘要', trigger: 'blur' }],
                bnK_SNO: [{ required: true, message: '請選擇銀行帳戶', trigger: 'change' }],
                dat: [{ required: true, message: '請選擇日期', trigger: 'change' }],
                amt: [{ required: true, message: '請輸入金額', trigger: 'blur' }],
            },
            oriAmt: 0,
        };
    },
    watch: {
        inputData(val) {
            if (val) {
                this.form.sno = val.sno;
                this.form.bnK_SNO = val.bnK_SNO;
                this.form.dat = val.dat;
                this.form.amt = val.amt;
                this.form.mem = val.mem;
                this.form.nam = val.nam;
            } else {
                this.form.sno = null;
                this.form.bnK_SNO = null;
                this.form.dat = Number(
                    moment()
                        .startOf('day')
                        .format('x'),
                );
                this.form.amt = null;
                this.form.mem = '';
                this.form.nam = null;
            }
        },
    },
    computed: {
        getTitle() {
            if (!this.form.sno) return '轉入零用現金';
            return '編輯零用現金';
        },
        isShowBankSelect() {
            // 編輯
            if (this.form.sno) {
                if (this.form.src === 2) return false;

                if (this.inputData.bnK_SNO) return true;
                // 編輯一般匯入
                return false; // 編輯初始金額
            }
            // 建立

            if (this.isInitial || this.form.src === 2) return false;
            // 建立初始金額
            return true; // 一般匯入
        },
        original_AMT() {
            if (this.inputData) {
                return this.inputData.amt;
            }
            return 0;
        },
        autoMem() {
            return this.isAmtChange ? `[編輯記錄: ${this.getUserName()} ${this.formatDate(new Date())}]\n原始金額：${this.original_AMT}\n編輯後金額：${this.form.amt}` : '';
        },
    },
    methods: {
        getUserName() {
            return this.$store.getters['account/userName'];
        },
        // eslint-disable-next-line camelcase
        formatDate(current_datetime) {
            return `${current_datetime.getFullYear()}-${
                current_datetime.getMonth() + 1
                // eslint-disable-next-line max-len
            }-${current_datetime.getDate()} ${current_datetime.getHours()}:${current_datetime.getMinutes()}`;
        },
        onAmtChange() {
            if (this.oriAmt - this.form.amt === 0) this.isAmtChange = false;
            else this.isAmtChange = true;
        },
        handleClose(refresh = false) {
            this.$refs.form.resetFields();
            this.$refs.form.clearValidate();
            this.resetForm();
            this.isAmtChange = false;
            this.$emit('close', refresh);
        },
        async onDelete() {
            try {
                await this.$confirm('確定要刪除零用金轉入？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                await this.$api({
                    url: 'FundManagementPage/Delete',
                    method: 'POST',
                    data: { sno: this.form.sno },
                });
                this.$message({
                    showClose: true,
                    message: '成功刪除轉入零用現金',
                    type: 'success',
                });
                this.$emit('close', true);
            } catch (e) {
                console.log(e);
            }
        },
        onOpen() {
            this.oriAmt = this.form.amt;
        },
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (!this.form.sno) this.submitAdd();
                    else this.submitUpdate();
                }
            });
        },
        handleTypeChange() {
            if (this.form.src === 2) {
                this.form.bnK_SNO = null;
            }
        },
        submitAdd() {
            this.isLoading = true;

            this.$api({
                url: 'FundManagementPage/TransferIn',
                method: 'POST',
                data: this.form,
            })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: '成功匯入零用現金。',
                        type: 'success',
                    });
                    this.handleClose(true);
                })
                .finally(() => {
                    this.isLoading = false;
                    this.resetForm();
                });
        },
        submitUpdate() {
            this.isLoading = true;
            this.$api({
                url: 'FundManagementPage/UpdateTransferInFund',
                method: 'POST',
                data: {
                    ...this.form,
                    mem: `${this.form.mem ? `${this.form.mem}\n` : ''}${this.autoMem}`,
                },
            })
                .then(() => {
                    this.handleClose(true);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        resetForm() {
            this.form.sno = null;
            this.form.bnK_SNO = null;
            this.form.dat = Number(
                moment()
                    .startOf('day')
                    .format('x'),
            );
            this.form.amt = null;
            this.form.mem = '';
            this.form.nam = null;
        },
    },
};
</script>
